module.exports = __webpack_public_path__ + "static/img/v70Bg-p.4166922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70Bg-p.png
// module id = D6iA
// module chunks = 1